export const breakpoints = {
  DESKTOP: 1280,
  LARGE_TABLET: 1024,
  TABLET: 768,
  LARGE_MOBILE: 600,
  MOBILE: 411,
};
